import APIFunction from './../services';

// get list order
export const listCustomer = (params) => {
    return APIFunction.queryCustomers(params).then((result) => {
        return result;
    }).catch(error => {
        return error;
    })
}

// create order in customer website
export const createCustomerOrder = (params) => {
    return APIFunction.createCustomerOrder(params).then((result) => {
        return result;
    }).catch(error => {
        return error;
    })
}

// list order in customer website
export const listCustomerOrder = (params) => {
    return APIFunction.queryCustomerOrders(params).then((result) => {
        return result;
    }).catch(error => {
        return error;
    })
}

// export order in customer website
export const exportCustomerOrder = (params) => {
    return APIFunction.exportCustomerOrder(params).then((result) => {
        return result;
    }).catch(error => {
        return error;
    })
}

// export template
export const exportTemplate = (params) => {
    return APIFunction.exportTemplate(params).then((result) => {
        return result;
    }).catch(error => {
        return error;
    })
}

// getReturnOrder
export const getReturnOrder = (params) => {
    return APIFunction.getReturnOrder(params).then((result) => {
        return result;
    }).catch(error => {
        return error;
    })
}

// exportOrderList
export const exportOrderList = (params) => {
    return APIFunction.exportOrderList(params).then((result) => {
        return result;
    }).catch(error => {
        return error;
    })
}

// exportReturnOrder
export const exportReturnOrder = (params) => {
    return APIFunction.exportReturnOrder(params).then((result) => {
        return result;
    }).catch(error => {
        return error;
    })
}

// exportOrderEcommList
export const exportOrderEcommList = (params) => {
    return APIFunction.exportOrderEcommList(params).then((result) => {
        return result;
    }).catch(error => {
        return error;
    })
}

export const updateCustomer = (params) => {
    return APIFunction.updateCustomer(params).then((result) => {
        return result;
    }).catch(error => {
        return error;
    })
}